import { render, staticRenderFns } from "./SegmentCancel.vue?vue&type=template&id=5bd372b9&"
import script from "./SegmentCancel.vue?vue&type=script&lang=js&"
export * from "./SegmentCancel.vue?vue&type=script&lang=js&"
import style0 from "./SegmentCancel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports